import Vue from 'vue'
import ShowDown from 'showdown'
import _ from 'lodash'
import Constants from '@/constants'
import Site from '@/apis/site'
// export const EventBus = new Vue({ el: '#app' }) <-- in this case access using import { EventBus }
export default new Vue({
  data: {
    info: {
      year: (new Date()).getFullYear(),
    },
    navMain: [
      {
        name: 'service',
        label: 'Services',
        // path: '/service',
        section: 'services',
        subnav: [],
        subnavOpen: false,
        subnavOpenMobile: false,
      }, {
        name: 'shop',
        label: 'Shop',
        url: 'https://alliedinstructionalshop.alliedinstructional.com/'
      }, {
        name: 'about',
        label: 'About Us',
        path: '/about'
      }, {
        name: 'testimonials',
        label: 'Testimonials',
        path: '/testimonials'
      }, {
        name: 'opportunities',
        label: 'Placement Opportunities',
        path: '/opportunities'
      }, {
        name: 'contact',
        label: 'Contact Us',
        path: '/contact'
      }
    ],

    opportunities: [
      {
        title: 'Teacher Of The Vision Impaired And/Or Orientation And Mobility Specialist',
        states: ['Florida', 'Georgia', 'Virginia', 'West Virginia', 'Kentucky', 'Tennessee', 'Maryland', 'Delaware', 'South Carolina'],
        created_at: '2021-10-09 18:06:21',
        content: `
**Qualifications**\n\
\n\
Must hold a Collegiate Professional License with endorsement in Deaf and Hard of Hearing, and successful teaching
experience working with students that are deaf or hard of hearing. The successful candidate will have:\n\
\n\
- Experience serving students utilizing auditory-verbal techniques as well as those using manual communication.\n\
- Excellent human relations, interpersonal communications, conflict resolution, organizational and planning skills are
required.\n\
- A comprehensive knowledge of Federal and State mandates and requirements as related to the provision of educational
services and supports for students with hearing impairments.\n\
- Comprehensive knowledge of characteristics of individuals with hearing impairments and other disabilities to include
developmental, cognitive, socio-cultural influences and health related problems.\n\
- The ability to recognize and respond to individual student differences.\n\
- The ability to work in a collaborative and cooperative manner with parents, co-workers, school staff and service providers.\n\
- Experience with window based computer and related software applications.\n\
- A valid driver’s license.\n\
`
      }, {
        title: 'Teacher Of The Deaf & Hard Of Hearing (Dhh)',
        states: ['Virginia'],
        created_at: '2021-10-01 18:06:21',
        content: `
**Qualifications**\n\
\n\
Must hold a Collegiate Professional License with endorsement in Deaf and Hard of Hearing, and successful teaching
experience working with students that are deaf or hard of hearing. The successful candidate will have:\n\
\n\
- Experience serving students utilizing auditory-verbal techniques as well as those using manual communication.\n\
- Excellent human relations, interpersonal communications, conflict resolution, organizational and planning skills are
required.\n\
- A comprehensive knowledge of Federal and State mandates and requirements as related to the provision of educational
services and supports for students with hearing impairments.\n\
- Comprehensive knowledge of characteristics of individuals with hearing impairments and other disabilities to include
developmental, cognitive, socio-cultural influences and health related problems.\n\
- The ability to recognize and respond to individual student differences.\n\
- The ability to work in a collaborative and cooperative manner with parents, co-workers, school staff and service providers.\n\
- Experience with window based computer and related software applications.\n\
- A valid driver’s license.\n\
`
      },
    ]
  },
  computed: {
    isDesktop: {
      get: function () {
        return this._isDesktop
      },
      set: function (isDesktop) {
        if (this._isDesktop !== isDesktop) {
          // do not update immediately, only change if necessary
          this._isDesktop = isDesktop
          this.$emit('isDesktopChanged', isDesktop)
        }
      }
    }
  },
  watch: {
  },
  mounted () {
    // console.log('-- EventBus mounted')
  },
  methods: {
    init: async function () {
      try {
        // this.$set(this, 'loading', true)
        let promises = []
        let promise
        promise = this.getServices()
        promises.push(promise)
        await Promise.all(promises)
        // this.$set(this, 'loading', false)
      } catch (error) {
        // this.$set(this, 'loading', false)
        this.$message({
          message: `Refresh failed: ${error.message || error}`,
          type: 'error'
        })
      }
    },

    async getServices () {
      this.setSubNav('service', [])
      let data = await Site.services()
      data = _.map(data, (item) => {
        // item.name = item.name
        // item.label = item.title
        item.label = item.subtitle
        item.path = `/service/${item.name}`
        return item
      })
      console.log('-- EventBus services', data)
      this.setSubNav('service', data)
    },

    devMode: function () {
      let url = Constants.BASE_API
      if (url.indexOf('.com') >= 0) {
        return 'production'
      } else if (url.indexOf('localhost') >= 0) {
        return 'development'
      }
      return undefined
    },

    loadImage: function (url) {
      return new Promise((resolve) => {
        let img = new Image()
        img.src = url
        img.onload = () => resolve(img)
      })
    },

    getHtml: function (content) {
      var converter = new ShowDown.Converter()
      var html = converter.makeHtml(content)
      return html
    },

    toggleSubnavOpen: function (name) {
      let navItem = _.find(this._data.navMain, ['name', name])
      if (navItem && navItem.hasOwnProperty('subnavOpen')) {
        navItem.subnavOpen = !navItem.subnavOpen
      }
    },

    getNav: function () {
      return this._data.navMain
    },

    setSubNav: function (name, subnav) {
      let navItem = _.find(this._data.navMain, ['name', name])
      if (navItem) {
        this.$set(navItem, 'subnav', subnav)
      }
    },

    detectIE: function () {
      /**
       * detect IE
       * returns version of IE or false, if browser is not Internet Explorer
       */
      var ua = window.navigator.userAgent

      // Test values; Uncomment to check result …

      // IE 10
      // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

      // IE 11
      // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

      // Edge 12 (Spartan)
      // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

      // Edge 13
      // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

      var msie = ua.indexOf('MSIE ')
      if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10)
      }

      var trident = ua.indexOf('Trident/')
      if (trident > 0) {
        // IE 11 => return version number
        var rv = ua.indexOf('rv:')
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10)
      }

      var edge = ua.indexOf('Edge/')
      if (edge > 0) {
        // Edge (IE 12+) => return version number
        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10)
      }

      // other browser
      return false
    }
  }
})
